module.exports = __webpack_public_path__ + "img/free-fa-v4deprecations.0808044.svg";